import { ErrorCode } from '@afterpaytouch/portal-api/types'
import { FetchVerificationErrorResponse, FetchVerificationWaitResponse } from '@afterpaytouch/event-verify'
import {
  RegistrationId,
  RegistrationData,
  CreateAccountRequest,
  registrationErrors as regErrors,
  CreateRegistration,
  CreateRegistrationRequest,
  CreateRegistrationResponse,
  TransformedCreateRegistrationResponse,
  RegistrationErrorCode,
} from '@afterpaytouch/registration'
export { RegistrationErrorCode }

// Re-export registrationErrors with a different name to avoid conflicts
export const registrationErrors = regErrors

// Re-export more types
export type {
  CreateAccountRequest,
  CreateRegistration,
  CreateRegistrationRequest,
  CreateRegistrationResponse,
  TransformedCreateRegistrationResponse,
  RegistrationData,
}

export enum RegistrationStatus {
  NotStarted,
  Created,
  CodeSent,
  CodeVerified,
  Completed,
  IDVerified,
  ContractAgreementAccepted,
  Error,
}

export const duplicateErrorCodeList: RegistrationErrorCode[] = [RegistrationErrorCode.ExistingPhoneNumberSendEmail, RegistrationErrorCode.ExistingPhoneNumber]

export interface RegistrationError {
  error: RegistrationErrorCode
  errorCode?: ErrorCode
  errorInfo?: unknown
}

export interface VerifyRegistrationMobileEventRequest {
  onSuccess: () => void
  onError: (d: FetchVerificationErrorResponse) => void
  onWaiting: (d: FetchVerificationWaitResponse) => void
}

// This interface is slightly different from the registration package version - it uses portalToken instead of transactionToken
export interface VerifyRegistrationAuthorizationRequest {
  registrationId: RegistrationId
  amplitudeSessionId: number
  consumer: RegistrationData
  portalToken: string
}
